import axios from 'axios'
import { useContext, useEffect, useState, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigationType } from 'react-router-dom'
import { format } from 'date-fns'
import { DELETE_FROM_PALLET, EDIT_ORDER_ROW, GET_PALLET_EXIST, SAVE_COMMENT_ON_PALLET } from '../../../../../../../modules/API/settings'
import { IS_NEW_PALLET, LOAD, LOAD_END, LOGOUT } from '../../../../../../../../store/actions/actionsTypes'
import { RootState } from '../../../../../../../../store/reducers/rootReducer'
import { vibrationFunc } from '../../../../../../../modules/vibrationModule'
import useFocus from '../../../../../../../generic/hooks/useFocus'
import { LikutModals } from '../../../../../../../modules/Context/CefiNum'
import { checkPackType } from '../../../../../../../generic/utils/checkPackType'
import selectBrodMigdal from '../../../../../../../generic/utils/selectBrodMigdal'
import { addIDForTheList } from '../../../../../../../generic/utils/addUIDForTheList'
import { Defaults } from '../../../../../../../modules/API/Defaults/defaults'
import { Gathering } from '../../../../../../../modules/API/Gathering/gathering'
import { handleNotifications } from '../../../../../../../generic/utils/handleNotifications'
import { Orders } from '../../../../../../../modules/API/Orders/orders'
import { LIKUT } from '../../../../../../../modules/API/Likut/likut'
import useCheckRights from '../../../../../../../generic/hooks/useCheckRights'
import { sanitizeQrJson } from '../../../../../../../generic/utils/sanitizerQrJson'
import { calcDiffFromCurrentDate } from '../../../../../../../generic/utils/forDate/calcDiffFromCurrentDate'
import { useBarcodeScanner } from '../../../../../../../generic/hooks/useBarcodeScanner'
import { useBrodMigdal } from '../../../../../../../generic/hooks/useBrodMigdal'
import useDataFetcher from '../../../../knisot/hooks/useFetchData'
import useConfigLefiMishkal from '../../../useConfigLefiMishkal'
import useConfig from '../../../useConfig'
import { UseLikutSectionParams } from '../../types/likutSection'
import {
    IManualProductSelection,
    buildManualDefaultPacks,
    buildManualOrderRowKey,
    buildManualReplacementPacks,
    findExactOrderRow,
    withNoTagCollection,
} from '../../helpers/manualProductEntry'

const useLikutSection = ({ getExistPalletInfo, getPallet, printPallet, setPrintersModal, printerNum }: UseLikutSectionParams) => {
    const [isWeightCalculation, calcWeightPerUnit] = useConfigLefiMishkal()
    const [isAddIdToDesc] = useConfig()
    const getToken = useSelector((state: RootState) => state.mainReducer.token);
    const user = useSelector((state: RootState) => state.mainReducer.user);
    const isOffice = user?.rights.includes("OFFICE")
    const getAzmanaNum = useSelector((state: RootState) => (state.likut as any).azmanaNum);
    const likutInfo = useSelector((state: RootState) => state.likut) as any;
    const Collect_Comm = useSelector((state: RootState) => (state.likut as any)?.order?.Collect_Comm);
    const packageList = useSelector((state: RootState) => state?.defaults?.packageList);
    const defaultPackageList = useSelector((state: RootState) => state.defaults.packageList);
    const defaults = useSelector((state: RootState) => state.defaults?.defaults);
    // TODO change after new package API
    const activeResons = selectBrodMigdal(defaults, 572, 'Logical_Value') && !likutInfo?.withoutAzmana;
    const deltaWeight = selectBrodMigdal(defaults, 431, 'Num_Value');
    const entryDaysToExpire = selectBrodMigdal(defaults, 656, 'Num_Value');
    const testForInitialPAcksOfAmount = selectBrodMigdal(defaults, 318, 'Logical_Value');
    const defaultArizaProductID = selectBrodMigdal(defaults, 414, 'Num_Value');
    const defaultArizaGrowerID = selectBrodMigdal(defaults, 412, 'Num_Value');
    const defaultArizaTranzit = selectBrodMigdal(defaults, 5, 'Num_Value');
    const { hasRight } = useCheckRights({ key: 'R1000' })
    const { getBrodMigdal } = useBrodMigdal()
    // BM 680: הוספת מוצר ידנית בליקוט — shows the "+" manual product add button
    const isAllowManualProductAdd = !!getBrodMigdal({ id: 680 })
    const artPass = selectBrodMigdal(defaults, 577, 'Text_Value')?.trim();
    const isAllowToPrint = selectBrodMigdal(defaults, 591, 'Logical_Value');
    const dispatch = useDispatch();
    const [inputRef, setInputFocus] = useFocus();
    const [azmanotList, setAzmanotList] = useState<any[]>([]);
    const [azmanotListDefault, setAzmanotListDefault] = useState<any[]>([]);
    const [existGoodsInPallet, setExistGoodsInPallet] = useState<any[]>([]);
    const [resonState, setResonState] = useContext<any>(LikutModals);
    const [selectAzmanaRowModal, setSelectAzmanaRowModal] = useState(false);
    const [orderTitle, setOrderTitle] = useState<any>(null)
    const [isLoadingProductList, setIsLoadingProductList] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState<any>(null)
    const [isOpenProductLocationModal, setIsOpenProductLocationModal] = useState(false)
    const [isOpenArizotModal, setIsOpenArizotModal] = useState(false);
    const [isOpenRemarkModal, setIsOpenRemarkModal] = useState(Collect_Comm?.trim() ? true : false)
    const [isOpenProductRemarkModal, setIsOpenProductRemarkModal] = useState(false)
    const [remarkState, setRemarkState] = useState({
        remark: ''
    })

    const [recID, setRecID] = useState<number | null>(null);
    const [goodsCode, setGoodsCode] = useState('')
    const [entryInformation, setEntryInformation] = useState<any[]>([])

    const [likutModalToggle, setLikutModalToggle] = useState(false)
    const [defaultPacks, setDefaultPacks] = useState<any>('')
    const [persents, setPersents] = useState(0);
    const [progressColor, setProgressColor] = useState('')
    const [packageType, setPackageType] = useState<any>(null)

    const [existArizotQty, setExistArizotQty] = useState<number | null>(null)
    const [existWeigthQty, setExistWeigthQty] = useState<number | null>(null)

    const [isOpenCheckArizot, setIsOpenCheckArizot] = useState(false);
    const [isOpenManualProductModal, setIsOpenManualProductModal] = useState(false);

    const isAllowMultipleSave = +likutInfo?.pallet?.palletNum !== 999999 && (hasRight || isOffice);
    const [locationKeys, setLocationKeys] = useState<string[]>([])
    const location = useLocation()
    const navigationType = useNavigationType()

    const {
        data: growersList
    } = useDataFetcher(
        Defaults.getGrowerList, 'data'
    )

    const {
        data: packageByCustomer
    } = useDataFetcher(
        Defaults.getPackageByCustomerID, `${orderTitle?.CustomerID || 0}`
    )

    useBarcodeScanner({
        onScan: (value) => {
            getGoodsInfoEntry(value)
        },
        duplicateScanWindowMs: 700,
    })
    useEffect(() => {
        if (navigationType === 'PUSH') {
            setLocationKeys([location.key])
        }
        if (navigationType === 'POP') {
            if (locationKeys[1] === location.key) {
                setLocationKeys(([_, ...keys]) => keys)
                // Handle forward event
            } else {
                setLocationKeys((keys) => [location.key, ...keys])
                getPallet(likutInfo?.clientId || 0);
                // Handle back event
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key, navigationType])

    const saveCheckedPalletInfo = async (data: any) => {
        try {
            await axios({
                method: 'patch',
                url: `${SAVE_COMMENT_ON_PALLET}${likutInfo?.pallet?.palletNum}`,
                headers: {
                    'Authorization': 'Bearer ' + getToken
                },
                data: {
                    "detailsDelivery": data,
                    "printerNum": 33
                }
            })
            dispatch({ type: IS_NEW_PALLET, payload: false });
        } catch (err: any) {
            handleNotifications(err?.response?.data?.message || 'משהו השתבש', { type: 'error' })
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        }
    }

    const checkGivenPacks = () => {
        let totalArizot = existGoodsInPallet.reduce((acc: any, cur: any) => {
            let check = checkPackType(defaultPackageList, cur.PackID);
            let temp = check !== '1' && check !== '2';
            if (temp) {
                if (check === 'ק') {
                    acc['קרטון'] = acc['קרטון'] ? acc['קרטון'] + cur?.Quantity : cur?.Quantity
                }
                else {
                    acc[cur.Pack_Name?.trim()] = acc[cur.Pack_Name?.trim()] ? acc[cur.Pack_Name?.trim()] + cur?.Quantity : cur?.Quantity
                }
            }
            return acc
        }, {})
        return totalArizot
    }

    useEffect(() => {
        setInputFocus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const selectGoodForLikut = (index: number) => {
        setDefaultPacks(azmanotList[index]);
        setLikutModalToggle(true);
    }
    const controller = useRef(new AbortController());

    const openGoodOreder = (defArr: any[]) => {
        if (!isWeightCalculation) {
            const filtered = defArr.filter(item => {
                return (item.OrderPacks - item.SupplyQty) > 0
            })
            setAzmanotList(filtered)
        } else {
            const filtered = defArr.filter(item => {
                // gave more than ordered → not "remaining to collect", hide even with a reason
                if (item.SupplyWeight > item.OrderWeight) return false
                const unit = calcWeightPerUnit(item)
                return (item.OrderWeight - item.SupplyWeight) >= unit || item.ScanProblem !== 0
            })
            setAzmanotList(filtered)
        }
    }

    const deleteItemFromPallet = async (id: number, item: any) => {
        let newArr = [...azmanotList].map(e => {
            if (e.RecID === item.OrderLineRef) {
                let temp = e.SupplyQty + item.Quantity
                e.SupplyQty = e.SupplyQty - item.Quantity
                e.SupplyWeight = e.SupplyWeight - item.WeightNeto
                if (temp === e.OrderPacks) {
                    e.ScanProblem = 0
                    e.ChangeReason = 0
                }
            }
            return e
        })

        dispatch({ type: LOAD })
        try {
            let res = await axios({
                method: 'delete',
                headers: {

                    'Authorization': 'Bearer ' + getToken
                },
                url: DELETE_FROM_PALLET + id
            })
            const filtered = existGoodsInPallet.filter(item => item.RecID !== id);
            setExistGoodsInPallet(filtered);
            setAzmanotList(newArr)
            handleNotifications(res?.data?.message, { type: "success" })
        } catch (err: any) {
            handleNotifications(err?.response?.data?.message || 'משהו השתבש', { type: 'error' })
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const editOrderRow = async (problem: number, reson: number) => {
        dispatch({ type: LOAD })
        try {
            axios({
                method: 'patch',
                headers: {
                    'Authorization': 'Bearer ' + getToken
                },
                url: EDIT_ORDER_ROW,
                data: {
                    "RecID": recID,
                    "ScanProblem": problem,
                    "ChangeReason": reson
                }
            })
            palletDetailes(likutInfo.pallet.palletNum)
            if (!likutInfo.withoutAzmana) {
                getAzmanotDetailes(+likutInfo?.azmanaNum);
            }

        } catch (err: any) {
            handleNotifications(err?.response?.data?.message || 'משהו השתבש', { type: 'error' })
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const getAzmanotDetailes = async (OrderID: number) => {
        setIsLoadingProductList(true)
        try {
            const res = await Orders.getOrderWithDetailsByOrderID(OrderID)
            const { OrderDetails, ...rest } = res
            let concatArr = addIDForTheList(OrderDetails);
            let sorted = concatArr.sort((a: any, b: any) => b.CollectorSort - a.CollectorSort)
            let arrIsue: any[] = []
            let arrWithoutIsue: any[] = []
            sorted.forEach((e: any) => {
                if (e.ChangeReason === 3) {
                    arrIsue.push(e)
                } else {
                    arrWithoutIsue.push(e)
                }
            })
            setOrderTitle(rest);
            const concated = arrWithoutIsue.concat(arrIsue)
            setAzmanotList(concated)
            openGoodOreder(concated)
            setAzmanotListDefault(concated)
        } catch (err: any) {
            handleNotifications(err?.response?.data?.message || 'משהו השתבש', { type: 'error' })
        } finally {
            setIsLoadingProductList(false)
        }
    }

    const errAlert = (err: any, param?: string): void => {
        // A plain string must not fall into the per-item recursion: err[0]/slice(1)
        // on a string toasts the message character by character.
        const list = Array.isArray(err) ? err : [err]
        list.forEach((item) => {
            handleNotifications(param ? item?.[param] : item, { type: 'error' })
        })
        setInputFocus();
    }

    const handleControlProductLocationModal = () => {
        setIsOpenProductLocationModal(!isOpenProductLocationModal)
    }
    const handleOpenProductLocationModal = (product: any) => {
        setSelectedProduct(product)
        setIsOpenProductLocationModal(true)
    }
    const saveArizotRequest = async (Qty: number, packID: number) => {
        if (Qty === 0 || !packID) {
            handleNotifications('בחר אריזה', { type: 'warning' })
            return
        }
        dispatch({ type: LOAD })
        try {
            let res = await axios({
                method: 'post',
                url: SAVE_COMMENT_ON_PALLET,
                headers: {
                    'Authorization': 'Bearer ' + getToken
                },
                data: {
                    "Quality": 0,
                    "Warehouse": defaultArizaTranzit || 0,
                    "GrowerID": defaultArizaGrowerID,
                    "ProductID": defaultArizaProductID,
                    'PalletNum': +likutInfo?.pallet?.palletNum,
                    'OrderNum': likutInfo?.withoutAzmana ? 0 : +likutInfo?.azmanaNum,
                    'Qty': Qty,
                    'PackID': packID,
                    "CustomerID": likutInfo?.withoutAzmana ? likutInfo?.clientId : 0,
                }
            })
            handleNotifications(res?.data?.message, { type: 'success' })
            updateExistPallets(likutInfo.pallet.palletNum);
        } catch (err: any) {
            handleNotifications(err?.response?.data?.message || 'משהו השתבש', { type: 'error' })

        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const isSelectedProduct = useMemo(() => azmanotList.some(item => !!item.isSelected), [azmanotList])


    const multipleSaveRequest = async () => {
        if (!isAllowMultipleSave) return
        dispatch({ type: LOAD })
        try {
            const requests = azmanotList.filter(item => item.isSelected).map(item => {
                const postData = {
                    QualityID: 0,
                    WarehouseID: defaultArizaTranzit || 0,
                    GrowerID: item.GrowerID || defaultArizaGrowerID,
                    ProductID: item.ProductID,
                    VarietyID: item.VarietyID,
                    PalletNum: +likutInfo?.pallet?.palletNum,
                    OrderNum: likutInfo?.withoutAzmana ? 0 : +likutInfo?.azmanaNum,
                    Qty: item.OrderPacks - item.SupplyQty,
                    Weight: item.OrderWeight - item.SupplyWeight,
                    PalletType: likutInfo?.pallet?.palletType || 0,
                    OrderRowRecID: item.RecID,
                    CustomerID: likutInfo?.withoutAzmana ? likutInfo?.clientId : 0,
                    ScanProblem: 0,
                    ChangeReason: 0,
                    Type_SaleCalculation: 0,
                    PackID: item.PackID,
                    SalePrice: 0
                }
                return LIKUT.postDataLikut(postData)
            })
            const res = await Promise.all(requests)
            updateExistPallets(res.at(-1).palletNum);
            if (!likutInfo.withoutAzmana) {
                await getAzmanotDetailes(+likutInfo?.azmanaNum);
            }
            handleNotifications("המוצרים שנבחרו נוספו בהצלחה", { type: 'success' })
        } catch (err: any) {
            handleNotifications(err?.response?.data?.message || 'משהו השתבש', { type: 'error' })
        } finally {
            dispatch({ type: LOAD_END })
        }
    }
    const saveAndClose = () => {
        getPallet(likutInfo?.clientId || 0);
        if (isAllowToPrint) {
            if (printerNum) {
                printPallet(likutInfo?.pallet?.palletNum)
            }
            else {
                setPrintersModal()
            }
        }
    }

    const handleSave = () => {
        if (isSelectedProduct) {
            multipleSaveRequest()
            return
        }
        saveAndClose()
    }


    const getGoodsInfoEntry = async (num: string) => {
        dispatch({ type: LOAD })
        setResonState({
            resonTag: null,
            action: null,
            active: false,
            props: {}
        })
        try {
            const permanentCode = num.split('#')
            let res: any

            // check if JSON string
            if (typeof num === 'string' && num.trim().startsWith('{') && num.trim().endsWith('}')) {
                const jsonObject = JSON.parse(sanitizeQrJson(num.trim()))
                // Normalize JSON object into expected structure
                res = {
                    entryLine: [
                        {
                            AmountPack: jsonObject.q,
                            AvgWeightPerPack: Number((jsonObject.w / jsonObject.q).toFixed(2)),
                            BalanceAmount: jsonObject.q,
                            BalanceWeight: jsonObject.w,
                            EntryDate: format(new Date(), 'yyyyMMdd'),
                            GeneralProductID: 0,
                            Gross: jsonObject.w,
                            GrowerID: jsonObject.g,
                            GrowerName: "",
                            ImageUrl: "",
                            MandatoryWeight: false,
                            PackID: jsonObject.k,
                            Pack_Name: "",
                            PackageTareWeight: 0,
                            Pallete_Desc: "",
                            ProductCalculationMethod: 0,
                            ProductDesc: "",
                            ProductFamilyDesc: "",
                            ProductFamilyId: 0,
                            ProductID: jsonObject.p,
                            Reject: false,
                            SizeDesc: jsonObject.s,
                            SizeNum: 0,
                            Tranzit: 0,
                            VarietyDesc: "",
                            VarietyID: jsonObject.v
                        }
                    ]
                }
            }
            else if (permanentCode.length > 1) {
                res = await Gathering.getPermanentKnisaByBarcode(permanentCode[1])
            } else {
                res = await Gathering.getKnisaByBarcode(num, getAzmanaNum)
            }
            dispatch({ type: LOAD_END })
            setGoodsCode(num)
            let resultObj
            // v2 permanent-knisa entryLine не несёт EntryDate — без даты проверка срока
            // неприменима (и calcDiffFromCurrentDate падал бы на undefined.substring).
            const srikaDate = res.entryLine[0]?.EntryDate
            const daysFromEntryDate = srikaDate ? calcDiffFromCurrentDate(srikaDate) : 0

            if (srikaDate && entryDaysToExpire !== 0 && daysFromEntryDate > entryDaysToExpire) {
                vibrationFunc('criticalError')
                handleNotifications("פג תוקף למדבקת כניסה", { type: "warning" })
                setGoodsCode('')
                return
            }


            const foundFull = azmanotListDefault.find(item => {
                return +item.ProductID === +res.entryLine[0]?.ProductID &&
                    +item.VarietyID === +res.entryLine[0]?.VarietyID &&
                    item.SizeID?.trim() === res.entryLine[0]?.SizeDesc?.trim()
            })
            if (foundFull) {
                resultObj = foundFull
            } else {
                const foundWithoutSize = azmanotListDefault.find(item => {
                    return +item.ProductID === +res.entryLine[0]?.ProductID &&
                        +item.VarietyID === +res.entryLine[0]?.VarietyID
                })
                const foundWithoutVariety = azmanotListDefault.find(item => {
                    return +item.ProductID === +res.entryLine[0]?.ProductID &&
                        +item.SizeID?.trim() === +res.entryLine[0]?.SizeDesc?.trim()
                })
                const foundWithProductID = azmanotListDefault.find(item => {
                    return +item.ProductID === +res.entryLine[0]?.ProductID
                })
                resultObj = foundWithoutSize || foundWithoutVariety || foundWithProductID
            }
            if (activeResons && !resultObj) {
                setEntryInformation(res.entryLine);
                setDefaultPacks(resultObj);
                setResonState({
                    ...resonState,
                    resonTag: 'notExistInAzmana',
                    active: true,
                    action: setLikutModalToggle,
                    props: {
                        srika: res.entryLine[0],
                        setDefProd: setDefaultPacks,
                        setRowModal: setSelectAzmanaRowModal
                    }
                })
                return
            }
            // v2 (go) может класть непустую строку message и в успешный ответ;
            // message = ошибка только когда скан не принёс данных (семантика v1 node).
            if (!res?.entryLine?.[0] && res?.message?.length > 0) {
                vibrationFunc('criticalError')
                errAlert(res?.message);
                setGoodsCode('')

            } else {
                vibrationFunc('success')
                setEntryInformation(res.entryLine)
                // search equal good in goodslist by id from entry request and update the state
                setDefaultPacks(resultObj);

                setLikutModalToggle(true);
                if (resultObj?.Remarks?.trim()) {
                    setRemarkState({
                        remark: resultObj.Remarks?.trim()
                    })
                    handleProductRemarkModal()
                }
            }
        } catch (err: any) {
            dispatch({ type: LOAD_END });
            handleNotifications(err?.response?.data?.message || 'משהו השתבש', { type: 'error' })
            setInputFocus();
            console.log(err)
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        }
    }

    const handleControlManualProductModal = () => {
        setIsOpenManualProductModal(!isOpenManualProductModal)
    }

    // Manual product flow: emulates the scan flow without a knisa —
    // goodsCode stays empty so useLikutEntry takes the withoutSrika branch.
    const handleManualProductSubmit = (selection: IManualProductSelection) => {
        setIsOpenManualProductModal(false)
        setGoodsCode('')
        setEntryInformation([])
        setResonState({
            resonTag: null,
            action: null,
            active: false,
            props: {}
        })
        const foundFull = findExactOrderRow(azmanotListDefault, buildManualOrderRowKey(selection))
        if (foundFull) {
            // NoTagCollection forced: a non-office user must still hit the withoutSrika save branch
            setDefaultPacks(withNoTagCollection(foundFull))
            setLikutModalToggle(true)
            if (foundFull?.Remarks?.trim()) {
                setRemarkState({
                    remark: foundFull.Remarks?.trim()
                })
                handleProductRemarkModal()
            }
            return
        }
        const manualPacks = buildManualDefaultPacks(selection)
        setDefaultPacks(manualPacks)
        if (activeResons) {
            setResonState({
                ...resonState,
                resonTag: 'notExistInAzmana',
                active: true,
                action: setLikutModalToggle,
                props: {
                    srika: manualPacks,
                    // Replacement keeps the hand-picked product identity; the chosen
                    // order row contributes only RecID and the quantity base.
                    setDefProd: (item: any) => setDefaultPacks(buildManualReplacementPacks(manualPacks, item)),
                    setRowModal: setSelectAzmanaRowModal
                }
            })
            return
        }
        setLikutModalToggle(true)
    }

    const checkForSiumLikut = () => {
        azmanotListDefault.filter(item => (item.OrderPacks - item.SupplyQty !== 0) && (item.ChangeReason === 0))

    }

    // calculation of packs quantity
    const collectAndSortExist = () => {
        let sorted = existGoodsInPallet?.reduce((sum, cur) => {
            let findPack = defaultPackageList.filter((e: any) => e.PackID === cur.PackID)[0]
            if (findPack?.Pack_Type === '1' || findPack?.Pack_Type === '2') return sum
            return sum + (cur.Quantity / (findPack?.Volume || 60) * 100)
        }, 0)
        setProgressColor(Math.floor(sorted) < 25 ? '#79BD8F' :
            Math.floor(sorted) >= 25 && Math.floor(sorted) < 50 ? '#B2C77F' :
                Math.floor(sorted) >= 50 && Math.floor(sorted) < 75 ? '#BD9E79' :
                    '#B2372D'
        )
        setPersents(Math.floor(sorted))

    }
    useEffect(() => {
        collectAndSortExist()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [existGoodsInPallet])

    const palletDetailes = async (code: number | string) => { // 99086
        setIsLoadingProductList(true)
        try {
            let res = await axios.get(`${GET_PALLET_EXIST}${code}`, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                }
            })
            if (Array.isArray(res.data.detailsPallet)) {
                let concatArr = addIDForTheList(res.data.orderDetails)
                setAzmanotList(concatArr)
                setAzmanotListDefault(concatArr)

            }

        } catch (err) {
            // console.log(err)
        } finally {
            setIsLoadingProductList(false)

        }

    }
    const updateExistPallets = async (palletNum: number) => {
        setExistGoodsInPallet(await getExistPalletInfo(palletNum));
    }

    useEffect(() => {
        if (!likutInfo.withoutAzmana) {
            getAzmanotDetailes(getAzmanaNum);
        }
        else if (likutInfo.withoutAzmana) {
            palletDetailes(likutInfo.pallet.palletNum)
        }
        updateExistPallets(likutInfo.pallet.palletNum);

        return () => {
            controller.current.abort('Component unmounted');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let weigthQty = existGoodsInPallet?.reduce((acc, cur) => {
            return acc += cur.WeightNeto
        }, 0)
        let packsQty = existGoodsInPallet?.reduce((acc, cur) => {
            return acc += cur.Quantity
        }, 0)
        setExistArizotQty(packsQty);
        setExistWeigthQty(weigthQty);
    }, [existGoodsInPallet])

    const selectFunc = (value: string) => {
        if (value === 'def') {
            openGoodOreder(azmanotListDefault);
        }
        else if (value === 'all') {
            setAzmanotList(azmanotListDefault);
        }
        else if (value === 'inPallet') {
            setAzmanotList([]);
        }

    }
    const savePallet = () => {
        getPallet(likutInfo?.clientId || 0);
        if (printerNum) {
            printPallet(likutInfo?.pallet?.palletNum)
        }

        else {
            setPrintersModal()
        }
    }

    const handleSelectOrderLine = (recID: number) => {
        // find the good in the list and add new Props or switch it
        const newArr = azmanotList.map(e => {
            if (e.RecID === recID) {
                e.isSelected = !!!e.isSelected
            }
            return e
        })
        setAzmanotList(newArr)


    }

    const handleProductRemarkModal = () => {
        setIsOpenProductRemarkModal(!isOpenProductRemarkModal)
    }

    return {
        // config / rights / redux
        likutInfo,
        getToken,
        user,
        isOffice,
        Collect_Comm,
        packageList,
        defaultPackageList,
        activeResons,
        testForInitialPAcksOfAmount,
        artPass,
        deltaWeight,
        isWeightCalculation,
        isAddIdToDesc,
        isAllowMultipleSave,
        growersList,
        packageByCustomer,
        // lists
        azmanotList,
        azmanotListDefault,
        existGoodsInPallet,
        isLoadingProductList,
        // header
        orderTitle,
        persents,
        progressColor,
        existArizotQty,
        existWeigthQty,
        // scan / entry
        goodsCode,
        setGoodsCode,
        entryInformation,
        getGoodsInfoEntry,
        likutModalToggle,
        setLikutModalToggle,
        defaultPacks,
        setDefaultPacks,
        packageType,
        setPackageType,
        isAllowManualProductAdd,
        isOpenManualProductModal,
        handleControlManualProductModal,
        handleManualProductSubmit,
        // modals flags
        selectAzmanaRowModal,
        setSelectAzmanaRowModal,
        selectedProduct,
        isOpenProductLocationModal,
        handleControlProductLocationModal,
        handleOpenProductLocationModal,
        isOpenArizotModal,
        setIsOpenArizotModal,
        isOpenRemarkModal,
        setIsOpenRemarkModal,
        isOpenProductRemarkModal,
        handleProductRemarkModal,
        remarkState,
        isOpenCheckArizot,
        setIsOpenCheckArizot,
        // rows interactions
        recID,
        setRecID,
        selectGoodForLikut,
        deleteItemFromPallet,
        editOrderRow,
        handleSelectOrderLine,
        isSelectedProduct,
        // save flows
        multipleSaveRequest,
        handleSave,
        savePallet,
        saveArizotRequest,
        saveCheckedPalletInfo,
        checkGivenPacks,
        // data updates
        getAzmanotDetailes,
        updateExistPallets,
        checkForSiumLikut,
        errAlert,
        selectFunc,
        // pass-through
        setInputFocus,
    }
}

export default useLikutSection;
